/**
 * Central configuration for stub data usage throughout the application
 *
 * This file allows toggling between real data and stub data for different features
 * in a consistent way across the application
 */

// Master switch - when false, all stub data is disabled regardless of individual settings
export const ENABLE_STUBS = true

// Feature-specific stub settings
// Only applied when ENABLE_STUBS is true
export const STUB_CONFIG = {
  // Archive/Email threads
  threads: false,

  // Alerts
  alerts: false,

  // BI Alerts
  bi_alerts: false,

  // Settings
  settings: false,

  // Filters
  filters: false,

  // Any other features that have stubs
  // example: true
}

/**
 * Convenience function to check if stubs should be used for a specific feature
 */
export function isStubEnabled(feature: keyof typeof STUB_CONFIG): boolean {
  return ENABLE_STUBS && STUB_CONFIG[feature]
}
